module.exports = __webpack_public_path__ + "static/img/qualification.9818586.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qualification.png
// module id = jIOG
// module chunks = 1